import React from 'react';
import ReactModal from 'react-modal';

import OverestimationLayout from './OverestimationLayout';

import './overestimation.scss';

const OverestimationModal = ({
  isOpen,
  handleCloseModal,
  data,
  submitOverestimation,
  view = false,
  modalError = false,
  isModalLoading = false,
  garage = false,
  isOverestimation = false,
  tab
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel="Modal"
      className="modal-container overestimation-modal-container"
      overlayClassName="modal-overlay">
      <OverestimationLayout
        handleCloseModal={handleCloseModal}
        submitOverestimation={submitOverestimation}
        data={data}
        view={view}
        modalError={modalError}
        isModalLoading={isModalLoading}
        garage={garage}
        isOverestimation={isOverestimation}
        tab={tab}
      />
    </ReactModal>
  );
};

export default OverestimationModal;
